import React from "react";
import { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from '@mui/icons-material/Add';
import TableSorter from "../../common/components/TableSorter";
import DataService from "../../common/services/dataService";
import {
  Paper,
  InputAdornment,
  IconButton,
  TablePagination,
  Checkbox,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Menu,
  Typography,
  Tooltip,
  TextField,
} from "@mui/material";
import { display, padding, width } from "@mui/system";

export const AdTypes = () => {
  const [adTypes, setAdTypes] = useState([]);
  const [orderBy, setOrderBy] = useState("id");

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showFilter, setShowFilter] = useState("");
  const [filterCode, setFilterCode] = useState("");
  const [filterWidth, setFilterWidth] = useState("");
  const [filterHeight, setFilterHeight] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);
  const [action, setAction] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedAdType, setSelectedAdType] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    name_single: "",
    description: "",
    code: "",
    width: "",
    height: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);

  const useStyles = {
    tableHeaders: {
      padding: ".25rem",
      width: "fit-content",
    
    },
    tableCells: {
      fontWeight: "400",
      fontSize: "0.875rem",
      lineHeight: "1.57",
      letterSpacing: "0.00714em",
    },
    dropdownCells: {
      width: "100%",
    },
  };

  useEffect(() => {
    const fetchAdTypes = async () => {
      try {
        const res = await DataService.getAdTypeList(orderBy);
        const adTypesData = res?.data || [];

        if (Array.isArray(adTypesData)) {
          setAdTypes(adTypesData);
        }
      } catch (err) {
        console.error("Failed to fetch AdTypes:", err);
      }
    };
    fetchAdTypes();
  }, [orderBy]);

  // Filter
  const filtered = adTypes.filter((adType) => {
    //search
    const matchesSearch = search
      ? adType.name_single?.toLowerCase().includes(search.toLowerCase()) ||
        adType.id?.toString().includes(search) ||
        adType.code?.toString().includes(search)
      : true;

    //dropdown filters
    const matchesCode = filterCode ? adType.code === filterCode : true;
    const matchesWidth = filterWidth
      ? adType.width === Number(filterWidth)
      : true;
    const matchesHeight = filterHeight
      ? adType.height === Number(filterHeight)
      : true;

    return matchesSearch && matchesCode && matchesWidth && matchesHeight;
  });

  const codes = [...new Set(adTypes.map((a) => a.code))];
  const widths = [...new Set(adTypes.map((a) => a.width))];
  const heights = [...new Set(adTypes.map((a) => a.height))];

  // sort
  const handleSortChange = (newSortValue) => {
    setOrderBy(newSortValue);
    setCurrentPage(0);
  };

  const sorted = [...filtered].sort((a, b) => {
    if (!orderBy) return 0;

    const isDesc = orderBy.endsWith("_desc");
    const key = orderBy.replace("_desc", "").replace("_asc", "");

    const aVal = a[key];
    const bVal = b[key];

    if (aVal == null || bVal == null) return 0;

    // *handle numbers - id, width, height
    const aNum = Number(aVal);
    const bNum = Number(bVal);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return isDesc ? bNum - aNum : aNum - bNum;
    }

    // *handle strings
    return isDesc
      ? String(bVal).localeCompare(String(aVal))
      : String(aVal).localeCompare(String(bVal));
  });

  // Pagination
  const start = currentPage * rowsPerPage;
  const paginated = sorted.slice(start, start + rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0);
  };

  //checkboxes
  const handleSelectRow = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  // commented out for future use
  // const handleSelectAll = () => {
  //   const currentPageIds = paginated.map((row) => row.id);

  //   const allSelected = currentPageIds.every((id) => selectedIds.includes(id));

  //   if (allSelected) {
  //     //unselect all
  //     setSelectedIds((prev) =>
  //       prev.filter((id) => !currentPageIds.includes(id)),
  //     );
  //   } else {
  //     //select all
  //     setSelectedIds((prev) => [...new Set([...prev, ...currentPageIds])]);
  //   }
  // };

  const handleActionChange = (selectedAction) => {
    setSelectedAdType(null);

    if (selectedAction === "add") {
      setSelectedAdType(null);
      setFormData({
        name: "",
        name_single: "",
        description: "",
        code: "",
        width: "",
        height: "",
      });
    }
    if (["copy", "edit"].includes(selectedAction)) {
      const selected = adTypes.find((a) => a.id === selectedIds[0]);

      if (!selected) {
        alert("Please select a valid row");
        return;
      }

      const baseData = {
        name: selected.name || "",
        name_single: selected.name_single || "",
        description: selected.description || "",
        code: selected.code || "",
        width: selected.width || "",
        height: selected.height || "",
      };

      if (selectedAction === "edit") {
        setSelectedAdType(selected);
        setFormData(baseData);
      }

      if (selectedAction === "copy") {
        setSelectedAdType(null);
        setFormData({
          ...baseData,
          name: baseData.name + " (Copy)",
          code: baseData.code,
        });
      }
    }

    setAction(selectedAction);
    setOpenModal(true);
  };

  const handleActionSelect = (selectedAction) => {
    setAnchorEl(null);

    if (["copy", "edit"].includes(selectedAction) && selectedIds.length !== 1) {
      alert("Please select one row");
      return;
    }
    // if (selectedAction === "delete" && selectedIds.length === 0) {
    //   alert("Please select at least one row");
    //   return;
    // }
    handleActionChange(selectedAction);
  };

  const handleSave = async () => {
    console.log("SENDING TO API:", formData);
    try {
      const formattedData = {
        ...selectedAdType,
          ...formData,
          width: formData.width ? Number(formData.width) : null,
          height: formData.height ? Number(formData.height) :null,
      }
      if (action === "edit" && selectedAdType) {

        await DataService.updateAdType(selectedAdType.id, formattedData);

      }
      if (action === "copy" || action === "add") {
        const {id, ...payload} = formattedData;
        await DataService.createAdType(payload);
      }

      //refresh table
      const res = await DataService.getAdTypeList(orderBy);
      setAdTypes(res?.data || []);

      setSelectedIds([]);
      setAction("");
      setOpenModal(false);
    } catch (err) {
      console.error("Action failed:", err);
    }
  };

  return (
    <Paper elevation={0}>
      <div
        style={{ display: "flex", padding: 4, justifyContent: "space-between" }}
      >
        <TextField
          style={{ zIndex: 0 }}
          autoFocus
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          id="outlined-basic"
          label="Search ad types..."
          variant="outlined"
        />

        {/* buttons container */}
        <div style={{display: "flex", gap: 24, alignItems: "center", left: "12rem", position: "relative"}}>
          {/*Add AdType Button */}
          <Button
            className="button-primary"
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={() => handleActionChange("add")}
            data-testid="createAdType"
            title="Create a new ad type."
          >
              Add Ad Type
          </Button>

          {/* Actions Button */}
          <div>
            <Button
            variant="contained"
            size="small"
            endIcon={<ExpandMoreIcon />}
            className={`button-secondary ${
              selectedIds.length === 0 ? "disabled" : ""
            }`}
            disabled={selectedIds.length === 0}
            onClick={(e) => setAnchorEl(e.currentTarget)}
            title={
              selectedIds.length > 0
                ? "Bulk actions for selected studies"
                : "Select an ad type"
            }
          >
            Actions
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {/* <MenuItem onClick={() => handleActionSelect("add")}>
              Add New Ad Type
            </MenuItem> */}
            <MenuItem onClick={() => handleActionSelect("copy")}>
              Copy Ad Type
            </MenuItem>
            <MenuItem onClick={() => handleActionSelect("edit")}>
              Edit Ad Type
            </MenuItem>

          </Menu>
          </div>

        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <Tooltip title="Filter adTypes">
            <IconButton onClick={() => setShowFilter((prev) => !prev)}>
              <FilterListIcon style={{ color: "rgb(99, 115, 129)" }} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      {showFilter && (
        <div style={{ display: "flex", gap: 16, padding: "0 16px 16px" }}>
          <TextField
            select
            label="Code"
            value={filterCode}
            onChange={(e) => {
              setFilterCode(e.target.value);
              setCurrentPage(0);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {codes.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Width"
            value={filterWidth}
            onChange={(e) => {
              setFilterWidth(e.target.value);
              setCurrentPage(1);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {widths.map((w) => (
              <MenuItem key={w} value={w}>
                {w}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Height"
            value={filterHeight}
            onChange={(e) => {
              setFilterHeight(e.target.value);
              setCurrentPage(1);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {heights.map((h) => (
              <MenuItem key={h} value={h}>
                {h}
              </MenuItem>
            ))}
          </TextField>
        </div>
      )}

      <div style={{ marginRight: 8, width: "100%" }}>
        <TablePagination
          component="div"
          count={sorted.length}
          page={currentPage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={(event, newPage) => handlePageChange(newPage)}
          onRowsPerPageChange={(event) =>
            handleRowsPerPageChange(parseInt(event.target.value, 10))
          }
        />
      </div>
      <div style={{ height: "55vh", overflowY: "scroll" }}>
        <table className="table">
          <thead>
            <tr>
              {/* select all checkboxes */}
              <th>
                {/* commented out for future use */}
                {/* <Checkbox 
                  checked={
                    paginated.length > 0 &&
                    paginated.every((row) => selectedIds.includes(row.id))
                  }
                  indeterminate={
                    paginated.some((row) => selectedIds.includes(row.id)) &&
                    !paginated.every((row) => selectedIds.includes(row.id))
                  }
                  onChange={handleSelectAll}
                /> */}
              </th>
              {[
                { label: "Id", key: "id" },
                { label: "Name", key: "name", width: "220px" },
                { label: "Name Single", key: "name_single", width: "150px" },
                { label: "Description", key: "description", width: "220px" },
                { label: "Code", key: "code"},
                { label: "Width", key: "width" },
                { label: "Height", key: "height" },
              ].map((col, index) => (
                <th key={col.key} style={{ 
                  ...useStyles.tableHeaders, 
                  width: col.width || useStyles.tableHeaders.width
                  }}>
                  <h4 style={{ display: "inline" }}>{col.label}</h4>

                  <TableSorter
                    name={col.key}
                    handleSortChange={handleSortChange}
                    currentOrderBy={orderBy}
                    rawSort={false}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginated.map((adType) => (
              <tr key={adType.id}>
                {/* checkboxes */}
                <td>
                  <Checkbox
                    checked={selectedIds.includes(adType.id)}
                    onChange={() => handleSelectRow(adType.id)}
                  />
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography title={adType.id}>{adType.id}</Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography title={adType.name} style={useStyles.tableCells}>
                    {adType.name}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adType.name_single}
                    style={useStyles.tableCells}
                  >
                    {adType.name_single}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adType.description}
                    style={useStyles.tableCells}
                  >
                    {adType.description}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography title={adType.code} style={useStyles.tableCells}>
                    {adType.code}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography title={adType.width} style={useStyles.tableCells}>
                    {adType.width}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adType.height}
                    style={useStyles.tableCells}
                  >
                    {adType.height}
                  </Typography>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>
          {action === "add" && "Add New Ad Type"}
          {action === "copy" && "Copy Ad Type"}
          {action === "edit" && "Edit Ad Type"}
        </DialogTitle>
        <DialogContent>
          {/* commented out for future use */}
          {/* {action === "delete" && (
            <div>
              Are you sure you want to delete {selectedIds.length} item(s)
            </div>
          )} */}
          {(action === "add" || action === "edit" || action === "copy") && (
            <>
              <TextField
                label="Name"
                fullWidth
                margin="dense"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
              <TextField
                label="Name Single"
                fullWidth
                margin="dense"
                value={formData.name_single}
                onChange={(e) =>
                  setFormData({ ...formData, name_single: e.target.value })
                }
              />
              <TextField
                label="Description"
                fullWidth
                margin="dense"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
              <TextField
                label="Code"
                fullWidth
                margin="dense"
                value={formData.code}
                onChange={(e) =>
                  setFormData({ ...formData, code: e.target.value })
                }
              />
              <TextField
                label="Width"
                fullWidth
                margin="dense"
                value={formData.width}
                onChange={(e) =>
                  setFormData({ ...formData, width: e.target.value })
                }
              />
              <TextField
                label="Height"
                fullWidth
                margin="dense"
                value={formData.height}
                onChange={(e) =>
                  setFormData({ ...formData, height: e.target.value })
                }
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button onClick={handleSave}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export const AdTypeGroups = () => {
  const [adTypeGroups, setAdTypeGroups] = useState([]);
  const [orderBy, setOrderBy] = useState("id");

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showFilter, setShowFilter] = useState(false);
  const [filterCode, setFilterCode] = useState("");
  const [filterNameSingle, setFilterNameSingle] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);
  const [action, setAction] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedAdTypeGroup, setSelectedAdTypeGroup] = useState(null);
  const [formData, setFormData] = useState({
    ad_asset_type_id: "",
    name: "",
    name_single: "",
    description: "",
    code: "",
  });
  const [assetTypes, setAdAssetTypes] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const useStyles = {
    tableHeaders: {
      paddingLeft: "5px",
      width: "fit-content",
    },
    tableCells: {
      fontWeight: "400",
      fontSize: "0.875rem",
      lineHeight: "1.57",
      letterSpacing: "0.00714em",
    },
    dropdownCells: {
      width: "100%",
    },
  };

  useEffect(() => {
    const fetchAdTypeGroups = async () => {
      // getAdTypeGroups handles its own errors and resolves undefined on failure
      const res = await DataService.getAdTypeGroups(orderBy);

      if (!res) {
        console.error("Failed to fetch AdType Groups");
        return;
      }

      const adTypeGroupsData = res.data || [];

      if (Array.isArray(adTypeGroupsData)) {
        setAdTypeGroups(adTypeGroupsData);
      }
    };
    fetchAdTypeGroups();
  }, [orderBy]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await DataService.getAdAssetTypes();
        setAdAssetTypes(res?.data || []);
      } catch (err) {
        console.error("Failed to load asset types:", err);
      }
    };
    fetchOptions();
  }, []);

  // Filter
  const filtered = adTypeGroups.filter((adTypeGroup) => {
    //search
    const matchesSearch = search
      ? adTypeGroup.name_single?.toLowerCase().includes(search.toLowerCase()) ||
        adTypeGroup.id?.toString().includes(search) ||
        adTypeGroup.code?.toString().includes(search)
      : true;

    //dropdown filters
    const matchesCode = filterCode ? adTypeGroup.code === filterCode : true;
    const matchesNameSingle = filterNameSingle
      ? adTypeGroup.name_single === filterNameSingle
      : true;

    return matchesSearch && matchesCode && matchesNameSingle;
  });

  const codes = [...new Set(adTypeGroups.map((a) => a.code))];
  const name_singles = [...new Set(adTypeGroups.map((a) => a.name_single))];

  // sort
  const handleSortChange = (newSortValue) => {
    setOrderBy(newSortValue);
    setCurrentPage(0);
  };

  const sorted = [...filtered].sort((a, b) => {
    if (!orderBy) return 0;

    const isDesc = orderBy.endsWith("_desc");
    const key = orderBy.replace("_desc", "").replace("_asc", "");

    const aVal = a[key];
    const bVal = b[key];

    if (aVal == null || bVal == null) return 0;

    // *handle numbers - id, width, height
    const aNum = Number(aVal);
    const bNum = Number(bVal);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return isDesc ? bNum - aNum : aNum - bNum;
    }

    // *handle strings
    return isDesc
      ? String(bVal).localeCompare(String(aVal))
      : String(aVal).localeCompare(String(bVal));
  });

  // Pagination
  const start = currentPage * rowsPerPage;
  const paginated = sorted.slice(start, start + rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0);
  };

  //checkboxes
  const handleSelectRow = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  // commented out for future use
  // const handleSelectAll = () => {
  //   const currentPageIds = paginated.map((row) => row.id);

  //   const allSelected = currentPageIds.every((id) => selectedIds.includes(id));

  //   if (allSelected) {
  //     //unselect all
  //     setSelectedIds((prev) =>
  //       prev.filter((id) => !currentPageIds.includes(id)),
  //     );
  //   } else {
  //     //select all
  //     setSelectedIds((prev) => [...new Set([...prev, ...currentPageIds])]);
  //   }
  // };

  const handleActionChange = (selectedAction) => {
    setSelectedAdTypeGroup(null);

    if (selectedAction === "add") {
      setSelectedAdTypeGroup(null);
      setFormData({
        ad_asset_type_id: "",
        name: "",
        name_single: "",
        description: "",
        code: "",
      });
    }
    if (["copy", "edit"].includes(selectedAction)) {
      const selected = adTypeGroups.find((a) => a.id === selectedIds[0]);

      if (!selected) {
        alert("Please select a valid row");
        return;
      }

      const baseData = {
        ad_asset_type_id:
          selected.ad_asset_type_id || selected.ad_asset_type?.id || selected.ad_asset_type || "",
        name: selected.name || "",
        name_single: selected.name_single || "",
        description: selected.description || "",
        code: selected.code || "",
      };

      if (selectedAction === "edit") {
        setSelectedAdTypeGroup(selected);
        setFormData(baseData);
      }

      if (selectedAction === "copy") {
        setSelectedAdTypeGroup(null);
        setFormData({
          ...baseData,
          name: baseData.name + " (Copy)",
          code: baseData.code,
        });
      }
    }

    setAction(selectedAction);
    setOpenModal(true);
  };

  const handleActionSelect = (selectedAction) => {
    setAnchorEl(null);

    if (["copy", "edit"].includes(selectedAction) && selectedIds.length !== 1) {
      alert("Please select one row");
      return;
    }
    // commented out for future use
    // if (selectedAction === "delete" && selectedIds.length === 0) {
    //   alert("Please select at least one row");
    //   return;
    // }
    handleActionChange(selectedAction);
  }

  const handleSave = async () => {
    try {
      const formattedData = {
        ...selectedAdTypeGroup,
        ...formData,
      }
      
      if (action === "edit" && selectedAdTypeGroup) {
        
        await DataService.updateAdTypeGroup(selectedAdTypeGroup.id, formattedData);
      }

      if (action === "copy" || action === "add") {
        const { id, ...payload } = formattedData;
        await DataService.createAdTypeGroup(payload);
      }

      //refresh table
      // getAdTypeGroups handles its own errors and resolves undefined on failure,
      // so throw to keep the existing "Save failed" path rather than emptying the table
      const res = await DataService.getAdTypeGroups(orderBy);

      if (!res) {
        throw new Error("Failed to refresh AdType Groups");
      }

      setAdTypeGroups(res.data || []);

      setSelectedIds([]);
      setAction("");
      setOpenModal(false);
      setSelectedAdTypeGroup(null);
    } catch (err) {
      console.error("Action failed:", err);
      alert("Save failed. Check console for details");
    }
  };

  return (
    <Paper elevation={0}>
      <div
        style={{ display: "flex", padding: 4, justifyContent: "space-between" }}
      >
        <TextField
          style={{ zIndex: 0 }}
          autoFocus
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(0);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          id="outlined-basic"
          label="Search ad type groups..."
          variant="outlined"
        />

        {/* buttons container */}
        <div style={{display: "flex", gap: 24, alignItems: "center", left: "12rem", position: "relative"}}>
          {/*Add AdType Group Button */}
          <Button
            className="button-primary"
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={() => handleActionChange("add")}
            data-testid="createAdTypeGroup"
            title="Create a new ad type group."
          >
              Add Ad Type Group
          </Button>

          {/* Actions Button */}
          <div>
            <Button
            variant="contained"
            size="small"
            endIcon={<ExpandMoreIcon />}
            className={`button-secondary ${
              selectedIds.length === 0 ? "disabled" : ""
            }`}
            disabled={selectedIds.length === 0}
            onClick={(e) => setAnchorEl(e.currentTarget)}
            title={
              selectedIds.length > 0
                ? "Bulk actions for selected studies"
                : "Select an ad type"
            }
          >
            Actions
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {/* <MenuItem onClick={() => handleActionSelect("add")}>
              Add New Ad Type Group
            </MenuItem> */}
            <MenuItem onClick={() => handleActionSelect("copy")}>
              Copy Ad Type Group
            </MenuItem>
            <MenuItem onClick={() => handleActionSelect("edit")}>
              Edit Ad Type Group
            </MenuItem>

          </Menu>
          </div>

        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <Tooltip title="Filter adType Groups">
            <IconButton onClick={() => setShowFilter((prev) => !prev)}>
              <FilterListIcon style={{ color: "rgb(99, 115, 129)" }} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      {showFilter && (
        <div style={{ display: "flex", gap: 16, padding: "0 16px 16px" }}>
          <TextField
            select
            label="Name Single"
            value={filterNameSingle}
            onChange={(e) => {
              setFilterNameSingle(e.target.value);
              setCurrentPage(0);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {name_singles.map((n) => (
              <MenuItem key={n} value={n}>
                {n}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Code"
            value={filterCode}
            onChange={(e) => {
              setFilterCode(e.target.value);
              setCurrentPage(0);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {codes.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </TextField>
        </div>
      )}

      <div style={{ marginRight: 8, width: "100%" }}>
        <TablePagination
          component="div"
          count={sorted.length}
          page={currentPage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={(event, newPage) => handlePageChange(newPage)}
          onRowsPerPageChange={(event) =>
            handleRowsPerPageChange(parseInt(event.target.value, 10))
          }
        />
      </div>
      <div style={{ height: "55vh", overflowY: "scroll" }}>
        <table className="table">
          <thead>
            <tr>
              {/* select all checkboxes */}
              <th>
                {/* commented out for future use */}
                {/* <Checkbox
                  checked={
                    paginated.length > 0 &&
                    paginated.every((row) => selectedIds.includes(row.id))
                  }
                  indeterminate={
                    paginated.some((row) => selectedIds.includes(row.id)) &&
                    !paginated.every((row) => selectedIds.includes(row.id))
                  }
                  onChange={handleSelectAll}
                /> */}
              </th>
              {[
                { label: "Id", key: "id", width: "50px" },
                { label: "Name", key: "name" },
                { label: "Name Single", key: "name_single" },
                { label: "Description", key: "description" },
                { label: "Code", key: "code" },
              ].map((col, index) => (
                <th key={col.key} 
                style={{ 
                  ...useStyles.tableHeaders,
                  ...(col.key === "id" && {
                    display: "flex",
                    alignItems: "center",
                    gap: "6px"
                  })
                  }}>
                  <h4 style={{ display: "inline" }}>{col.label}</h4>

                  <TableSorter
                    name={col.key}
                    handleSortChange={handleSortChange}
                    currentOrderBy={orderBy}
                    rawSort={false}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginated.map((adTypeGroup) => (
              <tr key={adTypeGroup.id}>
                {/* checkboxes */}
                <td>
                  <Checkbox
                    checked={selectedIds.includes(adTypeGroup.id)}
                    onChange={() => handleSelectRow(adTypeGroup.id)}
                  />
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography title={adTypeGroup.id}>
                    {adTypeGroup.id}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adTypeGroup.name}
                    style={useStyles.tableCells}
                  >
                    {adTypeGroup.name}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adTypeGroup.name_single}
                    style={useStyles.tableCells}
                  >
                    {adTypeGroup.name_single}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adTypeGroup.description}
                    style={useStyles.tableCells}
                  >
                    {adTypeGroup.description}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adTypeGroup.code}
                    style={useStyles.tableCells}
                  >
                    {adTypeGroup.code}
                  </Typography>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>
          {action === "copy" && "Copy Ad Type Group"}
          {action === "add" && "Add New Ad Type Group"}
          {action === "edit" && "Edit Ad Type Group"}
        </DialogTitle>
        <DialogContent>
          {/* commented out for future use */}
          {/* {action === "delete" && (
            <div>
              Are you sure you want to delete {selectedIds.length} item(s)
            </div>
          )} */}
          {(action === "add" || action === "edit" || action === "copy") && (
            <>
              {/* ad asset type dropdown */}
              <TextField
                select
                label="Ad Asset Type"
                fullWidth
                margin="dense"
                value={formData.ad_asset_type_id || ""}
                onChange={(e) =>
                  setFormData({ ...formData, ad_asset_type_id: e.target.value })
                }
                helperText="Select Asset Type ID"
              >
                {assetTypes.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name} (ID: {option.id})
                  </MenuItem>
                ))}
              </TextField>
              {/* modal form */}
              <TextField
                label="Name"
                fullWidth
                margin="dense"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />
              <TextField
                label="Name Single"
                fullWidth
                margin="dense"
                value={formData.name_single}
                onChange={(e) =>
                  setFormData({ ...formData, name_single: e.target.value })
                }
              />
              <TextField
                label="Description"
                fullWidth
                margin="dense"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
              <TextField
                label="Code"
                fullWidth
                margin="dense"
                value={formData.code}
                onChange={(e) =>
                  setFormData({ ...formData, code: e.target.value })
                }
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button onClick={handleSave}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export const AdAssetTypes = () => {
  const [adAssetTypes, setAdAssetTypes] = useState([]);
  const [orderBy, setOrderBy] = useState("id");

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showFilter, setShowFilter] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [filterDescription, setFilterDescription] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);
  const [action, setAction] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedAdAssetType, setSelectedAdAssetType] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);

  const useStyles = {
    tableHeaders: {
      paddingLeft: "5px",
      width: "fit-content",
    },
    tableCells: {
      fontWeight: "400",
      fontSize: "0.875rem",
      lineHeight: "1.57",
      letterSpacing: "0.00714em",
    },
    dropdownCells: {
      width: "100%",
    },
  };

  useEffect(() => {
    const fetchAdAssetTypes = async () => {
      try {
        const res = await DataService.getAdAssetTypes(orderBy);
        const adAssetTypesData = res?.data || [];

        if (Array.isArray(adAssetTypesData)) {
          setAdAssetTypes(adAssetTypesData);
        }
      } catch (err) {
        console.error("Failed to fetch Ad Asset Types:", err);
      }
    };
    fetchAdAssetTypes();
  }, [orderBy]);

  // Filter
  const filtered = adAssetTypes.filter((adAssetType) => {
    //search
    const matchesSearch = search
      ? adAssetType.name?.toLowerCase().includes(search.toLowerCase()) ||
        adAssetType.id?.toString().includes(search)
      : true;

    //dropdown filters
    const matchesName = filterName ? adAssetType.name === filterName : true;
    const matchesDescription = filterDescription
      ? adAssetType.description === filterDescription
      : true;

    return matchesSearch && matchesName && matchesDescription;
  });

  const name = [...new Set(adAssetTypes.map((a) => a.name))];
  const description = [...new Set(adAssetTypes.map((a) => a.description))];

  // sort
  const handleSortChange = (newSortValue) => {
    setOrderBy(newSortValue);
    setCurrentPage(1);
  };

  const sorted = [...filtered].sort((a, b) => {
    if (!orderBy) return 0;

    const isDesc = orderBy.endsWith("_desc");
    const key = orderBy.replace("_desc", "").replace("_asc", "");

    const aVal = a[key];
    const bVal = b[key];

    if (aVal == null || bVal == null) return 0;

    // *handle numbers - id, width, height
    const aNum = Number(aVal);
    const bNum = Number(bVal);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return isDesc ? bNum - aNum : aNum - bNum;
    }

    // *handle strings
    return isDesc
      ? String(bVal).localeCompare(String(aVal))
      : String(aVal).localeCompare(String(bVal));
  });

  // Pagination
  const start = currentPage* rowsPerPage;
  const paginated = sorted.slice(start, start + rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0);
  };

  //checkboxes
  const handleSelectRow = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  // commented out for future use
  // const handleSelectAll = () => {
  //   const currentPageIds = paginated.map((row) => row.id);

  //   const allSelected = currentPageIds.every((id) => selectedIds.includes(id));

  //   if (allSelected) {
  //     //unselect all
  //     setSelectedIds((prev) =>
  //       prev.filter((id) => !currentPageIds.includes(id)),
  //     );
  //   } else {
  //     //select all
  //     setSelectedIds((prev) => [...new Set([...prev, ...currentPageIds])]);
  //   }
  // };

  const handleActionChange = (selectedAction) => {
    setSelectedAdAssetType(null);

    if (selectedAction === "add") {
      setSelectedAdAssetType(null);
      setFormData({
        name: "",
        description: "",
      });
    }
    if (["copy", "edit"].includes(selectedAction)) {
      const selected = adAssetTypes.find((a) => a.id === selectedIds[0]);

      if (!selected) {
        alert("Please select a valid row");
        return;
      }

      if (selectedAction === "edit") {
        setSelectedAdAssetType(selected);
      }

      setFormData({
        name:
          selectedAction === "copy"
            ? selected.name + " (Copy)"
            : selected.name || "",
        description: selected.description || "",
      });
    }

    setAction(selectedAction);
    setOpenModal(true);
  };

  const handleActionSelect = (selectedAction) => {
    setAnchorEl(null);

    if (["copy", "edit"].includes(selectedAction) && selectedIds.length !== 1) {
      alert("Please select one row");
      return
  
    }
    // commented out for future use
    // if (selectedAction === "delete" && selectedIds.length === 0) {
    //   alert("Please select at least one row");
    //   return;
    // }
    handleActionChange(selectedAction);
  }

  const handleSave = async () => {
    try {
      const formattedData = {
        ...formData,
      };

      if (action === "edit" && selectedAdAssetType) {
        await DataService.updateAdAssetType(selectedAdAssetType.id, formattedData);
      }
      if (action === "copy" || action === "add") {
        const {id, ...payload} = formattedData;
        await DataService.createAdAssetType(payload);
      }

      //refresh table
      const res = await DataService.getAdAssetTypes(orderBy);
      setAdAssetTypes(res?.data || []);

      setSelectedIds([]);
      setAction("");
      setOpenModal(false);
      setSelectedAdAssetType(null);
    } catch (err) {
      console.error("Action failed:", err);
    }
  };

  return (
    <Paper elevation={0}>
      <div
        style={{
          display: "flex",
          padding: 16,
          justifyContent: "space-between",
        }}
      >
        <TextField
          style={{ zIndex: 0 }}
          autoFocus
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          id="outlined-basic"
          label="Search ad asset types..."
          variant="outlined"
        />

        {/* buttons container */}
        <div style={{display: "flex", gap: 24, alignItems: "center", left: "10rem", position: "relative"}}>
          {/*Add AdType Button */}
          <Button
            className="button-primary"
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={() => handleActionChange("add")}
            data-testid="createAdAssetType"
            title="Create a new ad type."
          >
              Add Ad Asset Type
          </Button>

          {/* Actions Button */}
          <div>
            <Button
            variant="contained"
            size="small"
            endIcon={<ExpandMoreIcon />}
            className={`button-secondary ${
              selectedIds.length === 0 ? "disabled" : ""
            }`}
            disabled={selectedIds.length === 0}
            onClick={(e) => setAnchorEl(e.currentTarget)}
            title={
              selectedIds.length > 0
                ? "Bulk actions for selected studies"
                : "Select an ad type"
            }
          >
            Actions
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {/* <MenuItem onClick={() => handleActionSelect("add")}>
              Add New Ad Asset Type
            </MenuItem> */}
            <MenuItem onClick={() => handleActionSelect("copy")}>
              Copy Ad Asset Type
            </MenuItem>
            <MenuItem onClick={() => handleActionSelect("edit")}>
              Edit Ad Asset Type
            </MenuItem>

          </Menu>
          </div>

        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <Tooltip title="Filter ad Asset Types">
            <IconButton onClick={() => setShowFilter((prev) => !prev)}>
              <FilterListIcon style={{ color: "rgb(99, 115, 129)" }} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      {showFilter && (
        <div style={{ display: "flex", gap: 16, padding: "0 16px 16px" }}>
          <TextField
            select
            label="Name"
            value={filterName}
            onChange={(e) => {
              setFilterName(e.target.value);
              setCurrentPage(1);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {name.map((n) => (
              <MenuItem key={n} value={n}>
                {n}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Description"
            value={filterDescription}
            onChange={(e) => {
              setFilterDescription(e.target.value);
              setCurrentPage(1);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {description.map((d) => (
              <MenuItem key={d} value={d}>
                {d}
              </MenuItem>
            ))}
          </TextField>
        </div>
      )}

      <div style={{ marginRight: 8, width: "100%" }}>
        <TablePagination
          component="div"
          count={sorted.length}
          page={currentPage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={(event, newPage) => handlePageChange(newPage)}
          onRowsPerPageChange={(event) =>
            handleRowsPerPageChange(parseInt(event.target.value, 10))
          }
        />
      </div>
      <div style={{ height: "55vh", overflowY: "scroll" }}>
        <table className="table">
          <thead>
            <tr>
              {/* select all checkboxes */}
              <th>
                {/* commented out for future use */}
                {/* <Checkbox
                  checked={
                    paginated.length > 0 &&
                    paginated.every((row) => selectedIds.includes(row.id))
                  }
                  indeterminate={
                    paginated.some((row) => selectedIds.includes(row.id)) &&
                    !paginated.every((row) => selectedIds.includes(row.id))
                  }
                  onChange={handleSelectAll}
                /> */}
              </th>
              {[
                { label: "Id", key: "id" },
                { label: "Name", key: "name" },
                { label: "Description", key: "description" },
              ].map((col, index) => (
                <th key={col.key} style={{ ...useStyles.tableHeaders }}>
                  <h4 style={{ display: "inline" }}>{col.label}</h4>

                  <TableSorter
                    name={col.key}
                    handleSortChange={handleSortChange}
                    currentOrderBy={orderBy}
                    rawSort={false}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginated.map((adAssetType) => (
              <tr key={adAssetType.id}>
                {/* checkboxes */}
                <td>
                  <Checkbox
                    checked={selectedIds.includes(adAssetType.id)}
                    onChange={() => handleSelectRow(adAssetType.id)}
                  />
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography title={adAssetType.id}>
                    {adAssetType.id}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adAssetType.name}
                    style={useStyles.tableCells}
                  >
                    {adAssetType.name}
                  </Typography>
                </td>

                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adAssetType.description}
                    style={useStyles.tableCells}
                  >
                    {adAssetType.description}
                  </Typography>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>
          {action === "copy" && "Copy Ad Asset Type"}
          {action === "add" && "Add New Ad Asset Type"}
          {action === "edit" && "Edit Ad Asset Type"}
        </DialogTitle>
        <DialogContent>
          {(action === "add" || action === "edit" || action === "copy") && (
            <>
              <TextField
                label="Name"
                fullWidth
                margin="dense"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />

              <TextField
                label="Description"
                fullWidth
                margin="dense"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button onClick={handleSave}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};

export const AdTypeOwners = () => {
  const [adTypeOwners, setAdTypeOwners] = useState([]);
  const [orderBy, setOrderBy] = useState("id");

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [showFilter, setShowFilter] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [filterDescription, setFilterDescription] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);
  const [action, setAction] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedAdTypeOwner, setSelectedAdTypeOwner] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    code: "",
  });
  const [adAssetOwners, setAdAssetOwners] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);


  const useStyles = {
    tableHeaders: {
      paddingLeft: "5px",
      width: "fit-content",
    },
    tableCells: {
      fontWeight: "400",
      fontSize: "0.875rem",
      lineHeight: "1.57",
      letterSpacing: "0.00714em",
    },
    dropdownCells: {
      width: "100%",
    },
  };

  useEffect(() => {
    const fetchAdTypeOwners = async () => {
      try {
        const res = await DataService.getAdTypeOwners(orderBy);
        const adTypeOwnersData = res?.data || [];

        if (Array.isArray(adTypeOwnersData)) {
          setAdTypeOwners(adTypeOwnersData);
        }
      } catch (err) {
        console.error("Failed to fetch Ad Asset Types:", err);
      }
    };
    fetchAdTypeOwners();
  }, [orderBy]);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await DataService.getAdAssetTypes();
        setAdAssetOwners(res?.data || []);
      } catch (err) {
        console.error("Failed to load asset types:", err);
      }
    };
    fetchOptions();
  }, []);

  // Filter
  const filtered = adTypeOwners.filter((adTypeOwner) => {
    //search
    const matchesSearch = search
      ? adTypeOwner.name?.toLowerCase().includes(search.toLowerCase()) ||
        adTypeOwner.id?.toString().includes(search)
      : true;

    //dropdown filters
    const matchesName = filterName ? adTypeOwner.name === filterName : true;
    const matchesDescription = filterDescription
      ? adTypeOwner.description === filterDescription
      : true;

    return matchesSearch && matchesName && matchesDescription;
  });

  const name = [...new Set(adTypeOwners.map((a) => a.name))];
  const description = [...new Set(adTypeOwners.map((a) => a.description))];

  // sort
  const handleSortChange = (newSortValue) => {
    setOrderBy(newSortValue);
    setCurrentPage(0);
  };

  const sorted = [...filtered].sort((a, b) => {
    if (!orderBy) return 0;

    const isDesc = orderBy.endsWith("_desc");
    const key = orderBy.replace("_desc", "").replace("_asc", "");

    const aVal = a[key];
    const bVal = b[key];

    if (aVal == null || bVal == null) return 0;

    // *handle numbers - id, width, height
    const aNum = Number(aVal);
    const bNum = Number(bVal);

    if (!isNaN(aNum) && !isNaN(bNum)) {
      return isDesc ? bNum - aNum : aNum - bNum;
    }

    // *handle strings
    return isDesc
      ? String(bVal).localeCompare(String(aVal))
      : String(aVal).localeCompare(String(bVal));
  });

  // Pagination
  const start = currentPage * rowsPerPage;
  const paginated = sorted.slice(start, start + rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(0);
  };

  //checkboxes
  const handleSelectRow = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  // commented out for future use
  // const handleSelectAll = () => {
  //   const currentPageIds = paginated.map((row) => row.id);

  //   const allSelected = currentPageIds.every((id) => selectedIds.includes(id));

  //   if (allSelected) {
  //     //unselect all
  //     setSelectedIds((prev) =>
  //       prev.filter((id) => !currentPageIds.includes(id)),
  //     );
  //   } else {
  //     //select all
  //     setSelectedIds((prev) => [...new Set([...prev, ...currentPageIds])]);
  //   }
  // };

  const handleActionChange = (selectedAction) => {
    setSelectedAdTypeOwner(null);

    if (selectedAction === "add") {
      setSelectedAdTypeOwner(null);
      setFormData({
        ad_asset_type_id: "",
        name: "",
        description: "",
        code: "",
      });
    }
    if (["copy", "edit"].includes(selectedAction)) {
      const selected = adTypeOwners.find((a) => a.id === selectedIds[0]);

      if (!selected) {
        alert("Please select a valid row");
        return;
      }

      const baseData = {
        ad_asset_type_id:
          selected.ad_asset_type_id || selected.ad_asset_type || "",
        name: selected.name || "",
        description: selected.description || "",
        code: selected.code || "",
      };

      if (selectedAction === "edit") {
        setSelectedAdTypeOwner(selected);
        setFormData(baseData);
      }

      if (selectedAction === "copy") {
        setSelectedAdTypeOwner(null);
        setFormData({
          ...baseData,
          name: baseData.name + " (Copy)",
          description: baseData.description,
          code: baseData.code,
        });
      }
    }

    setAction(selectedAction);
    setOpenModal(true);
  };

  const handleActionSelect = (selectedAction) => {
    setAnchorEl(null);

    if (["copy", "edit"].includes(selectedAction) && selectedIds.length !== 1) {
      alert("Please select one row");
    }
    // if (selectedAction === "delete" && selectedIds.length === 0) {
    //   alert("Please select at least one row");
    //   return;
    // }
    handleActionChange(selectedAction);
  };

  const handleSave = async () => {
    try {
      const formattedData = {
        ...formData,
      }
      if (action === "edit" && selectedAdTypeOwner) {
        await DataService.updateAdTypeOwner(selectedAdTypeOwner.id, formattedData);
      }
      if (action === "copy" || action === "add") {
        const { id, ...payload } = formattedData;
        await DataService.createAdTypeOwner(payload);
      }

      //refresh table
      const res = await DataService.getAdTypeOwners(orderBy);
      setAdTypeOwners(res?.data || []);

      setSelectedIds([]);
      setAction("");
      setOpenModal(false);
      setSelectedAdTypeOwner(null);
    } catch (err) {
      console.error("Action failed:", err);
      alert("Save failed. Check console for details");
    }
  };

  return (
    <Paper elevation={0}>
      <div
        style={{
          display: "flex",
          padding: 16,
          justifyContent: "space-between",
        }}
      >
        <TextField
          style={{ zIndex: 0 }}
          autoFocus
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(0);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          id="outlined-basic"
          label="Search ad type owners..."
          variant="outlined"
        />

        {/* buttons container */}
        <div style={{display: "flex", gap: 24, alignItems: "center", left: "10rem", position: "relative"}}>
          {/*Add AdType Owner Button */}
          <Button
            className="button-primary"
            variant="contained"
            size="small"
            startIcon={<AddIcon />}
            onClick={() => handleActionChange("add")}
            data-testid="createAdTypeOwner"
            title="Create a new ad type owner."
          >
              Add Ad Type Owner
          </Button>

          {/* Actions Button */}
          <div>
            <Button
            variant="contained"
            size="small"
            endIcon={<ExpandMoreIcon />}
            className={`button-secondary ${
              selectedIds.length === 0 ? "disabled" : ""
            }`}
            disabled={selectedIds.length === 0}
            onClick={(e) => setAnchorEl(e.currentTarget)}
            title={
              selectedIds.length > 0
                ? "Bulk actions for selected studies"
                : "Select an ad type"
            }
          >
            Actions
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {/* <MenuItem onClick={() => handleActionSelect("add")}>
              Add New Ad Type Owner
            </MenuItem> */}
            <MenuItem onClick={() => handleActionSelect("copy")}>
              Copy Ad Type Owner
            </MenuItem>
            <MenuItem onClick={() => handleActionSelect("edit")}>
              Edit Ad Type Owner
            </MenuItem>

          </Menu>
          </div>

        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <Tooltip title="Filter ad Asset Types">
            <IconButton onClick={() => setShowFilter((prev) => !prev)}>
              <FilterListIcon style={{ color: "rgb(99, 115, 129)" }} />
            </IconButton>
          </Tooltip>
        </div>
      </div>
      {showFilter && (
        <div style={{ display: "flex", gap: 16, padding: "0 16px 16px" }}>
          <TextField
            select
            label="Name"
            value={filterName}
            onChange={(e) => {
              setFilterName(e.target.value);
              setCurrentPage(0);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {name.map((n) => (
              <MenuItem key={n} value={n}>
                {n}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Description"
            value={filterDescription}
            onChange={(e) => {
              setFilterDescription(e.target.value);
              setCurrentPage(0);
            }}
            style={useStyles.dropdownCells}
          >
            <MenuItem value="">All</MenuItem>
            {description.map((d) => (
              <MenuItem key={d} value={d}>
                {d}
              </MenuItem>
            ))}
          </TextField>
        </div>
      )}

      <div style={{ marginRight: 8, width: "100%" }}>
        <TablePagination
          component="div"
          count={sorted.length}
          page={currentPage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100]}
          onPageChange={(event, newPage) => handlePageChange(newPage)}
          onRowsPerPageChange={(event) =>
            handleRowsPerPageChange(parseInt(event.target.value, 10))
          }
        />
      </div>
      <div style={{ height: "55vh", overflowY: "scroll" }}>
        <table className="table">
          <thead>
            <tr>
              {/* select all checkboxes */}
              <th>
                {/* commented out for future use */}
                {/* <Checkbox
                  checked={
                    paginated.length > 0 &&
                    paginated.every((row) => selectedIds.includes(row.id))
                  }
                  indeterminate={
                    paginated.some((row) => selectedIds.includes(row.id)) &&
                    !paginated.every((row) => selectedIds.includes(row.id))
                  }
                  onChange={handleSelectAll}
                /> */}
              </th>
              {[
                { label: "Id", key: "id" },
                { label: "Name", key: "name" },
                { label: "Description", key: "description" },
                { label: "Code", key: "code"}
              ].map((col, index) => (
                <th key={col.key} style={{ ...useStyles.tableHeaders }}>
                  <h4 style={{ display: "inline" }}>{col.label}</h4>

                  <TableSorter
                    name={col.key}
                    handleSortChange={handleSortChange}
                    currentOrderBy={orderBy}
                    rawSort={false}
                  />
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginated.map((adTypeOwner) => (
              <tr key={adTypeOwner.id}>
                {/* checkboxes */}
                <td>
                  <Checkbox
                    checked={selectedIds.includes(adTypeOwner.id)}
                    onChange={() => handleSelectRow(adTypeOwner.id)}
                  />
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography title={adTypeOwner.id}>
                    {adTypeOwner.id}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adTypeOwner.name}
                    style={useStyles.tableCells}
                  >
                    {adTypeOwner.name}
                  </Typography>
                </td>

                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adTypeOwner.description}
                    style={useStyles.tableCells}
                  >
                    {adTypeOwner.description}
                  </Typography>
                </td>
                <td style={useStyles.tableHeaders}>
                  <Typography
                    title={adTypeOwner.code}
                    style={useStyles.tableCells}
                  >
                    {adTypeOwner.code}
                  </Typography>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

     
      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogTitle>
          {action === "copy" && "Copy Ad Type Owner"}
          {action === "add" && "Add New Ad Type Owner"}
          {action === "edit" && "Edit Ad Type Owner"}
          {/* {action === "delete" && "Delete Ad Type Owner"} */}
        </DialogTitle>
        <DialogContent>
          {/* commented out for future use */}
          {/* {action === "delete" && (
            <div>
              Are you sure you want to delete {selectedIds.length} item(s)
            </div>
          )} */}
          {(action === "add" || action === "edit" || action === "copy") && (
            <>
             {/* ad asset type dropdown */}
              <TextField
                select
                label="Ad Asset Type"
                fullWidth
                margin="dense"
                value={formData.ad_asset_type_id || ""}
                onChange={(e) =>
                  setFormData({ ...formData, ad_asset_type_id: e.target.value })
                }
                helperText="Select Asset Type ID"
              >
                {adAssetOwners.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name} (ID: {option.id})
                  </MenuItem>
                ))}
              </TextField>
              {/* modal form */}
              <TextField
                label="Name"
                fullWidth
                margin="dense"
                value={formData.name}
                onChange={(e) =>
                  setFormData({ ...formData, name: e.target.value })
                }
              />

              <TextField
                label="Description"
                fullWidth
                margin="dense"
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />

              <TextField
                label="Code"
                fullWidth
                margin="dense"
                value={formData.code}
                onChange={(e) =>
                  setFormData({ ...formData, code: e.target.value })
                }
              />
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Cancel</Button>
          <Button onClick={handleSave}>Confirm</Button>
        </DialogActions>
      </Dialog>
    </Paper>
  );
};
